import React, { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';
import ModalLoad from '../../../components/modal/ModalLoad';

import SolarCell from '../../../components/cell/SolarCell';
import InverterBox from '../../../components/cell/InverterBox';
import InverterBorder from '../../../components/cell/InverterBorder';
import ScrollToTopButton from '../../../components/extra/ScrollToTopButton.js';
import DeviceInfo_Inverter from '../../../components/device_info/DeviceInfo_Inverter.js';

function MeasurementPVLayout(props) {
    const [chart_mode, setChart_mode] = useState('ac_type');
    const [chart_buffer, setChart_buffer] = useState({
        label: '',
        plot: []
    });
    const [inverter_item, setInverter_item] = useState({
        pvstring: [],
        pvstring_support: 0
    });
    const [inverter_selected, setInverter_selected] = useState('');
    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [data_inverter, setData_inverter] = useState([]);
    const [data_uioption, setData_uioption] = useState({ inverter_alarm: [] });
    const [string_tag_list, setString_tag_list] = useState([])
    const [string_selected, setString_selected] = useState({
        datakey: '',
        tags: ''
    });
    const [blink_cmd, setBlink_cmd] = useState({ inv_tag: '', inv: 0, pv: 0 })
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    useEffect(() => {
        var temp_tag = []
        for (var i = 0; i < 28; i++) {
            var channel = (i + 1)
            temp_tag.push({ table: 'PV String', tagname: 'pv_' + channel + '_p', display: 'PV' + channel + ' Power', value: false, unit: 'kW', index: i, channel: channel })
        }
        setString_tag_list(temp_tag)
    }, []);

    useEffect(() => {
        return () => {
            setChart_buffer({})
            setInverter_item({})
            setData_inverter([])
            setData_uioption({})
            setString_tag_list([])
            setChart_plot({})
        };
    }, []);

    useEffect(() => {
        if (props.data_uioption !== null && props.data_uioption !== undefined) {
            if (props.data_uioption.inverter_alarm !== null && props.data_uioption.inverter_alarm !== undefined) {
                setData_uioption(props.data_uioption)
            }
        }
    }, [props.data_uioption]);

    useEffect(() => {
        if (props.data_uioption !== null && props.data_uioption !== undefined) {
            if (props.data_uioption.pv_layout !== null && props.data_uioption.pv_layout !== undefined) {
                if (props.data_uioption.pv_layout.plot !== null && props.data_uioption.pv_layout.plot !== undefined) {
                    setPlot_layout(props.data_uioption.pv_layout.plot)
                }
            }
        }
    }, [props.data_uioption]);

    useEffect(() => {
        if (props.data_inverter !== null) {
            setData_inverter(props.data_inverter)
        }
    }, [props.data_inverter]);

    useEffect(() => {
        if (inverter_selected !== '') {
            const found = data_inverter.find((element) => element.inverter_id_text === inverter_selected);
            if (found !== undefined) {
                setInverter_item(found)
                api_get_inverter_power(inverter_selected, found.pvstring_support)
            } else {
                setInverter_item({
                    pvstring: [],
                    pvstring_support: 0
                })
            }
        } else {
            setChart_plot({
                ...chart_plot,
                IRR: [],
                Power: [],
                XLabel: '',
                Tags: '',
            })
            setInverter_item({
                pvstring: [],
                pvstring_support: 0
            })
        }
    }, [inverter_selected, data_inverter]);

    useEffect(() => {
        if (chart_buffer.plot !== undefined) {
            if (chart_buffer.plot.length > 0) {
                let arr1 = []
                let arr2 = []
                let arr3 = []
                for (let i = 0; i < chart_buffer.plot.length; i++) {
                    const dx = new Date(chart_buffer.plot[i].timestamp)
                    arr1.push({ x: dx, y: chart_buffer.plot[i]["env.total_irr_avg"] })
                    arr2.push({ x: dx, y: chart_buffer.plot[i][inverter_selected.toLowerCase() + ".active_power"] })
                    arr3.push({ x: dx, y: chart_buffer.plot[i][inverter_selected.toLowerCase() + ".mppt_power"] })
                }
                if (chart_mode === "ac_type") {
                    setChart_plot({
                        ...chart_plot,
                        IRR: arr1,
                        Power: arr2,
                        XLabel: chart_buffer.label,
                        Tags: 'AC Power',
                    })
                } else {
                    setChart_plot({
                        ...chart_plot,
                        IRR: arr1,
                        Power: arr3,
                        XLabel: chart_buffer.label,
                        Tags: 'DC Power',
                    })
                }
            } else {
                setChart_plot({
                    ...chart_plot,
                    IRR: [],
                    Power: [],
                    XLabel: '',
                    Tags: '',
                })
                setChart_plot_string({
                    ...chart_plot,
                    IRR: [],
                    Power: [],
                    XLabel: '',
                    Tags: '',
                })
            }
        }
    }, [chart_buffer, chart_mode]);

    useEffect(() => {

        if (chart_buffer.plot.length > 0 && string_selected.datakey !== "") {
            let arr1 = []
            let arr2 = []
            for (let i = 0; i < chart_buffer.plot.length; i++) {
                const dx = new Date(chart_buffer.plot[i].timestamp)
                arr1.push({ x: dx, y: chart_buffer.plot[i]["env.total_irr_avg"] })
                arr2.push({ x: dx, y: chart_buffer.plot[i][inverter_selected.toLowerCase() + "." + string_selected.datakey] })
            }
            setChart_plot_string({
                ...chart_plot_string,
                IRR: arr1,
                Power: arr2,
                XLabel: chart_buffer.label,
                Tags: string_selected.tags,
            })
        } else {
            setChart_plot_string({
                ...chart_plot_string,
                IRR: [],
                Power: [],
                XLabel: '',
                Tags: '',
            })
        }
    }, [chart_buffer, string_selected.datakey]);

    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(confirmcode) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    const [chart_plot, setChart_plot] = useState({
        XLabel: '',
        Power: [],
        IRR: [],
        Tags: 'AC Power',
        Chart1_Style: {
            irr_type: "line",
            solar_type: "area",
            irr_unit: "W/m2",
            solar_unit: "kW",
            axis_y1: 'Power (kW)',
            axis_y2: 'Irradiation (W/m2)',
            xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: '-'
        }
    });

    const [chart_plot_string, setChart_plot_string] = useState({
        XLabel: '',
        Power: [],
        IRR: [],
        Tags: 'String Power',
        Chart1_Style: {
            irr_type: "line",
            solar_type: "area",
            irr_unit: "W/m2",
            solar_unit: "kW",
            axis_y1: 'Power (kW)',
            axis_y2: 'Irradiation (W/m2)',
            xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: '-'
        }
    });

    async function api_get_inverter_power(inverter_id, string_sopport) {
        if (string_sopport > 0) {
            let pv_arr = []
            for (let i = 0; i < string_sopport; i++) {
                pv_arr.push(inverter_id.toLowerCase() + '.pv_' + (i + 1) + "_p")
            }

            const formData = new FormData()
            formData.append('datetype', "auto")
            formData.append('reportdate', "")
            formData.append('taglist', "env.total_irr_avg#" + inverter_id.toLowerCase() + ".active_power#" + inverter_id.toLowerCase() + ".mppt_power#" + pv_arr.join("#"))
            formData.append('validate', "all")

            axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/historical/rawdata", formData, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data;',
                    "Authorization": "Bearer " + props.permitdata.token
                },
            })
                .then((response) => {
                    if (response.data.status === 'OK') {
                        if (response.data.tabledata !== null) {
                            setChart_buffer({
                                ...chart_buffer,
                                label: response.data.xlabel,
                                plot: response.data.tabledata
                            })
                        }
                    } else {

                    }
                })
                .catch((err) => {

                });
        } else {

        }
    }

    function getInverterIcon(data) {
        const value = data?.connection_logger;
        if (value === undefined || value === null) {
            return <h5 className="card-title font-weight-bold mb-0"> {data.inverter_id_text} <span className='tagalarm alarming'>Unknown Logger State</span></h5>
        }
        if (data.connection_logger === true) {
            if (data.connection_device === true) {
                return <h5 className="card-title font-weight-bold mb-0"> {data.inverter_id_text} <span className='tagalarm normal'>Online</span>{getFaultIcon(data)} {getShutdownIcon(data)} {getPLimitIcon(data)}</h5>
            }
            return <h5 className="card-title font-weight-bold mb-0"> {data.inverter_id_text} <span className='tagalarm alarming'>Device Offline</span></h5>
        }
        return <h5 className="card-title font-weight-bold mb-0"> {data.inverter_id_text} <span className='tagalarm alarming'>Logger Offline</span></h5>
    }

    function getFaultIcon(data) {
        const value = data?.fault_code_text;
        if (value === undefined || value === null) {
            return null
        }
        if (data.fault_code !== 0 || (data.fault_code_text !== "0" && data.fault_code_text !== "")) {
            return <span className='tagalarm alarming'>Fault</span>
        }
        return null
    }

    function getShutdownIcon(data) {
        const value = data?.is_run_shutdown;
        if (value === undefined || value === null) {
            return null
        }
        if (!data.is_run_shutdown) {
            return <span className='tagalarm alarming'>Shutdown</span>
        }
        return null
    }

    function getPLimitIcon(data) {
        const value = data?.inverter_state;
        if (value === undefined || value === null) {
            return null
        }
        if (data.inverter_state === 513) {
            return <span className='tagalarm warning-orange'>P Limit</span>
        }
        return null
    }

    function ReadTags_SerialNo(data) {
        const value = data?.serial_no;
        if (value === undefined || value === null) {
            return null
        }
        if (data.serial_no !== undefined && data.serial_no !== "") {
            return <h6 className="update-time mt-0 mb-0">Serial No. : {data.serial_no}</h6>
        }
        return <h6 className="update-time mt-0 mb-0">Serial No. :</h6>
    }

    function ReadTags_SerialNoSubSystem(data) {
        const value = data?.meter_sn;
        if (value === undefined || value === null) {
            return null
        }
        if (data.meter_sn !== undefined && data.meter_sn !== "") {
            if (data.subsystem !== undefined && data.subsystem !== "") {
                return <p className="update-time mt-0 mb-0">Meter S/N. : {data.meter_sn}, {data.subsystem}</p>
            }
            return <p className="update-time mt-0 mb-0">Meter S/N. : {data.meter_sn}</p>
        }
        return null
    }

    function ReadTags(data, tag, digit) {
        const value = data?.[tag];
        if (value === undefined || value === null) {
            return "-"
        }
        return data[tag].toFixed(digit)
    }

    function ReadTags_string(data, tag) {
        const value = data?.[tag];
        if (value === undefined || value === null) {
            return "-"
        }
        return data[tag]
    }

    function ReadTags_Thounsand(data, tag, digit) {
        const value = data?.[tag];
        if (value === undefined || value === null) {
            return "-"
        }
        return data[tag].toLocaleString('en-US', { minimumFractionDigits: digit, maximumFractionDigits: digit })
    }

    function GetINVAlarmWordBit(data, tags, word_index, bit_index, text_color_on, text_color_off) {
        const value = data?.[tags]?.[word_index];
        if (value === undefined || value === null) {
            return <div className='inverter-alarm-lamp '></div>
        }
        if (data.connection_logger === true && data.connection_device === true) {
            var alarm_word_arr = data[tags][word_index]
            if (alarm_word_arr[bit_index] === true) {
                return <div className={'inverter-alarm-lamp ' + text_color_on}></div>
            }
            return <div className={'inverter-alarm-lamp ' + text_color_off}></div>
        }
        return <div className='inverter-alarm-lamp '></div>
    }

    function GetMessage_Connection(data, text_color_on, text_color_off) {
        const value = data?.connection_logger;
        if (value === undefined || value === null) {
            return <span className="unknown">Unknown</span>
        }
        if (data.connection_logger === true) {
            if (data.connection_device === true) {
                return <span className={text_color_on}>Device Online</span>
            }
            return <span className={text_color_off}>Device Offline</span>
        }
        return <span className={text_color_off}>Logger Offline</span>
    }

    function ReadTags_ZeroDetectColor(data, tag) {
        const value = data?.[tag];
        if (value === undefined || value === null) {
            return ""
        }
        if (data[tag] > 0) {
            return " alarmevent-text-green"
        }
        return ""
    }

    function getFaultnfo(data) {
        const value = data?.fault_code_text;
        if (value === undefined || value === null) {
            return null
        }
        if (data.fault_code !== 0 || (data.fault_code_text !== "0" && data.fault_code_text !== "")) {
            return <div className="measure-rows">
                <div className="measure-cell px-2 border-bottom">Fault Info</div>
                <div className="measure-cell numberright border-bottom font-sarabun text-danger">{data.fault_code_text}</div>
                <div className="measure-cell measunits border-bottom"></div>
            </div>
        }
        return null
    }

    function getINVStateColor(data) {
        const value = data?.inverter_state_text;
        if (value === undefined || value === null) {
            return ""
        }
        if (data.inverter_state_text.includes("Shutdown")) {
            return " col-rx-red"
        }
        return ""
    }

    const [plot_layout, setPlot_layout] = useState([])

    function get_inverter_data(id) {
        if (data_inverter !== null && data_inverter !== undefined) {
            if (data_inverter.length > 0) {
                return data_inverter[id - 1]
            }
        }
        return null
    }

    function get_cell_color(plotrows) {
        let plot_color = ['solar-color-bg-grey', 'solar-color-bg-grey', 'solar-color-bg-grey', 'solar-color-bg-grey', 'solar-color-bg-grey']
        if (plotrows === null) {
            return plot_color
        }

        if (plotrows.length > 0) {
            let id = 0
            plotrows.forEach((elem, index) => {
                id += 1
                if (data_inverter !== null && data_inverter !== undefined) {
                    if (data_inverter[elem.inv - 1] !== null && data_inverter[elem.inv - 1] !== undefined) {
                        if (data_inverter[elem.inv - 1].connection_logger !== undefined) {
                            if (data_inverter[elem.inv - 1].connection_logger === true) {
                                if (data_inverter[elem.inv - 1].connection_device === true) {
                                    if (data_inverter[elem.inv - 1].fault_code === 0 && data_inverter[elem.inv - 1].is_run_shutdown === true) {
                                        if (data_inverter[elem.inv - 1].pvstring !== null && data_inverter[elem.inv - 1].pvstring !== undefined) {
                                            if (data_inverter[elem.inv - 1].pvstring[elem.pv - 1] !== undefined) {
                                                if (data_inverter[elem.inv - 1].pvstring[elem.pv - 1].power_string > 0) {
                                                    plot_color[id - 1] = 'solar-color-bg-green'
                                                } else {
                                                    plot_color[id - 1] = 'solar-color-bg-blue'
                                                }
                                            } else {
                                                plot_color[id - 1] = 'solar-color-bg-grey'
                                            }
                                        } else {
                                            plot_color[id - 1] = 'solar-color-bg-grey'
                                        }
                                    } else {
                                        plot_color[id - 1] = 'alarming'
                                    }
                                } else {
                                    plot_color[id - 1] = 'alarming'
                                }
                            } else {
                                plot_color[id - 1] = 'alarming'
                            }
                        } else {
                            plot_color[id - 1] = 'solar-color-bg-grey'
                        }
                    } else {
                        plot_color[id - 1] = 'solar-color-bg-grey'
                    }
                } else {
                    plot_color[id - 1] = 'solar-color-bg-grey'
                }
            });
        }
        return plot_color
    }

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="mdi mdi-view-week-outline color-orange"></i> PV Layout</h4>
                                    <p className="mb-1">Monitoring your solar cell with installation layout style.</p>
                                    <h6 className='mb-0'><i className="mdi mdi-clock-time-four-outline"></i> Update : {props.server_update !== "-" ? moment(new Date(props.server_update)).format("YYYY-MM-DD HH:mm:ss") : "Unknown"}</h6>
                                </div>
                                <div>
                                    {BackCenter()}
                                </div>
                            </div>
                            <hr className="new-section-xs mb-2" />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="card card-common">
                                <div className="card-body pb-0 py-1 px-1">
                                    <div className="d-block">
                                        <h5 className="card-title font-weight-bold mb-0"><i className="mdi mdi-view-week-outline"></i> PV Layout</h5>
                                        <div className='py-0 my-0 mt-0 fw-600'>PV Color Definition</div>
                                        <div className='d-flex gap-3 flex-wrap mt-0 mb-3'>
                                            <p className='mb-0 mt-0'><i className='mdi mdi-rectangle solar-color-txt-green'></i>Power Production</p>
                                            <p className='mb-0 mt-0'><i className='mdi mdi-rectangle alarmevent-text-red'></i>Offline, Fault, Shutdown</p>
                                            <p className='mb-0 mt-0'><i className='mdi mdi-rectangle solar-color-txt-blue'></i>No Power</p>
                                            <p className='mb-0 mt-0'><i className='mdi mdi-rectangle solar-color-txt-grey'></i>Unknown</p>
                                        </div>
                                    </div>
                                    <hr className="new-section-xs mb-2" />

                                    <div className='panel-layout-wrapper'>
                                        <div className="solor-layout">
                                            <img alt='layout' src={process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/files/reader?key=" + props.data_uioption.layout_key + "&&pathdir=config&&filename=layout_img_" + props.permitdata.sitecode + ".png"} />
                                            {
                                                plot_layout !== undefined ?
                                                    plot_layout.map((plot, index2) => (
                                                        plot.type === "header" ?
                                                            <div className='solor-location font-sarabun' style={{ left: plot.x, top: plot.y }} key={'header-' + index2}>{plot.name}</div>
                                                            : plot.type === "inverter" ?
                                                                <InverterBox key={index2} plotdata={plot}
                                                                    invdata={get_inverter_data(plot.inv)}
                                                                    onClick={(inv_no) => { setInverter_selected(inv_no); setChart_mode("ac_type") }} />
                                                                : plot.type === "cell" ?
                                                                    <SolarCell key={index2} plotdata={plot} cell_color={get_cell_color(plot.row)} blink_cmd={blink_cmd}
                                                                        onClick={(inv_no, pv_tag, pv_display) => {
                                                                            setInverter_selected(inv_no);
                                                                            setString_selected({
                                                                                datakey: pv_tag,
                                                                                tags: pv_display
                                                                            });
                                                                            setChart_mode("ac_type")
                                                                        }}
                                                                    />
                                                                    : plot.type === "border" ?
                                                                        <InverterBorder key={index2} plotdata={plot} />
                                                                        : plot.type === "tag" ?
                                                                            <div className='solar-tag' style={{ top: plot.y + "px", left: plot.x + "px" }} key={index2}>{plot.name}</div>
                                                                            :
                                                                            null
                                                    ))
                                                    :
                                                    null
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div >
                        </div>
                    </div>
                </div>
            </div>

            {
                inverter_selected !== '' && inverter_item !== null && inverter_item ?
                    inverter_item.inverter_id_text !== undefined ?
                        <DeviceInfo_Inverter
                            data_uioption={data_uioption}
                            inverter_item={inverter_item}
                            chart_plot={chart_plot}
                            chart_plot_string={chart_plot_string}
                            string_tag_list={string_tag_list}
                            string_selected={string_selected}
                            chart_mode={chart_mode}
                            onClose={() => {
                                setInverter_selected('');
                                setString_selected({
                                    datakey: '',
                                    tags: ''
                                });
                                setChart_plot({
                                    ...chart_plot,
                                    IRR: [],
                                    Power: [],
                                })
                            }}
                            onSelected_ChartMode={setChart_mode}
                            onSelected_String={setString_selected}
                        ></DeviceInfo_Inverter>
                        :
                        null
                    :
                    null
            }

            <ScrollToTopButton />
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}
export default MeasurementPVLayout